/* eslint-disable max-lines */
import { useQueryClient, useInfiniteQuery, useQuery } from 'react-query'
import DataLoader from 'dataloader'

import {
  HTTPMethod,
  request,
  type ApiResponse,
} from '../../global/api/legacyApi'

type WebinarCategory = {
  album_id: number
  title: string
  content: string
  url_stub: string
  one: string
  content_text: string
}

type WebinarDTO = {
  albums?: WebinarCategory[]
  after_webinar_headline: string // 'Thank you for attending!'
  after_webinar_link: string // ''
  after_webinar_message: string // 'Thank you for taking part in this webinar. We are very happy you joined us today.'
  album_id: number // 8431973
  allow_guest_speakers_p: boolean // true
  auto_promote_p: boolean // false
  auto_record_p: boolean // false
  before_webinar_countdown_p: boolean // true
  broadcasting_p: boolean // false
  broadcasting_duration: number // 0,
  broadcasting_duration_fmt: string // '15h 53m'
  broadcasting_start_time: string // ''
  broadcasting_start_time__date: string // ''
  broadcasting_start_time__time: string // ''
  broadcasting_start_time_epoch: string // ''
  cancelled_p: boolean // false
  can_download_webinar_recording_p: boolean // true
  comment_mode: 'all' | 'none' // 'all'
  creation_date: string // '2023-10-08 16:24:20.532494+00'
  creation_date__date: string // 'October 08, 2023'
  customized_locale_texts_p: boolean // false
  description: string // ''
  description_html: string // ''
  description_text: string // ''
  display_location: string // ''
  draft_p: boolean // false
  duration_minutes: number | '' // 30
  enable_ondemand_p: boolean // true
  external_id: string // ''
  has_deck_p: boolean // false
  hls_dvr_stream: string // ''
  hls_dvr_url: string // ''
  hls_stream: string // 'https://live.delivery.staging.twentythree.systems/live/amlst:null:dev-8458034-4b73f30afab7477908c0.mp4/playlist.m3u8'
  hls_url: string // 'https://live.delivery.staging.twentythree.systems/live/amlst:null:dev-8458034-4b73f30afab7477908c0.mp4/playlist.m3u8'
  keyframe_download: string // ''
  last_broadcasting_start_time: string // ''
  last_broadcasting_start_time__date: string // ''
  last_broadcasting_start_time__time: string // ''
  last_broadcasting_start_time_epoch: string // ''
  link: string // '/asdf-100'
  live_date: string // '2023-10-17 13:25:00'
  live_date__date: string // 'October 17, 2023'
  live_date__time: string // '13:25'
  live_date_epoch: number // 1697541900
  live_format: 'webinar' // 'webinar'
  live_id: number // 8458034
  live_label: 'Live' | 'Waiting Room' | 'Upcoming' | 'On Demand' // 'Live'
  live_series_id: string // ''
  live_series_token: string // ''
  live_status: 'live' | 'upcoming' | 'previous' | '' // 'live'
  locale: string // 'en_US'
  location: string // ''
  location_city: string // ''
  location_country_iso: string // ''
  live_conversion_views: number
  location_latitude: string // ''
  location_longitude: string // ''
  name: string // 'asdf'
  next_end_time: string // '2023-10-17 13:55:00'
  next_end_time__date: string // 'October 17, 2023'
  next_end_time__time: string // '13:55'
  next_end_time_epoch: number // 1697543700
  next_start_time: string // '2023-10-17 13:25:00'
  next_start_time__date: string // 'October 17, 2023'
  next_start_time__time: string // '13:25'
  next_start_time_epoch: number // 1697541900
  preview_large_aspect_ratio: string // ''
  preview_large_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/large/download-3-thumbnail.jpg'
  preview_medium_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/medium/download-3-thumbnail.jpg'
  preview_photo_id: number // 8458044
  preview_portrait_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/portrait/download-3-thumbnail.jpg'
  preview_quad16_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/quad16/download-3-thumbnail.jpg'
  preview_quad50_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/quad50/download-3-thumbnail.jpg'
  preview_quad75_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/quad75/download-3-thumbnail.jpg'
  preview_quad100_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/quad100/download-3-thumbnail.jpg'
  preview_small_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/small/download-3-thumbnail.jpg'
  preview_standard_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/standard/download-3-thumbnail.jpg'
  preview_stock_p: boolean // true
  preview_token: string // 'a1e9d845e850e2b97b3c476ef57941eb'
  preview_tree_id: number // 7340
  primary_timezone: string // 'Europe/Copenhagen'
  primary_timezone_live_date: string // '2023-10-17 13:25:00'
  primary_timezone_live_date__date: string // 'October 17, 2023'
  primary_timezone_live_date__time: string // '13:25'
  private_p: boolean // false
  promoted_p: boolean // false
  protected_p: boolean // false
  protected_token: string // ''
  protection_method: string // ''
  publish_recordings_p: boolean // false
  publish_server: string // 'rtmp://live-wowza.staging.twentythree.systems/live'
  publish_stream: string // 'mp4:dev-8458034-4b73f30afab7477908c0.mp4?76c2561c8b74df91d9ff9529ccd2e281ad722893'
  publish_stream__180p: string // 'mp4:dev-8458034-4b73f30afab7477908c0.300.mp4?76c2561c8b74df91d9ff9529ccd2e281ad722893'
  publish_stream__360p: string // 'mp4:dev-8458034-4b73f30afab7477908c0.800.mp4?76c2561c8b74df91d9ff9529ccd2e281ad722893'
  publish_stream__720p: string // 'mp4:dev-8458034-4b73f30afab7477908c0.2000.mp4?76c2561c8b74df91d9ff9529ccd2e281ad722893'
  publish_stream__mbr: string // 'mp4:dev-8458034-4b73f30afab7477908c0.mbr3.mp4?2c6e11071974099ed70bf988f7497efa39d8fa87'
  question_mode: 'ask' | 'none' // 'ask'
  registration_mode: 'all' | 'none' // "all"
  registration_page_link: string // ''
  short_link: string // '/asdf-100'
  streaming_method:
    | 'mobile'
    | 'software'
    | 'iphone'
    | 'hardware'
    | 'webcam'
    | 'android' // "webcam"
  streaming_p: boolean // false
  streaming_start_time: string // ''
  streaming_start_time__date: string // ''
  streaming_start_time__time: string // ''
  streaming_start_time_epoch: string // ''
  speakers: WebinarSpeakerDTO[]
  template_p: boolean // false
  thumbnail_360_p: boolean // false
  thumbnail_large_aspect_ratio: string // ''
  thumbnail_large_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/large/download-3-thumbnail.jpg'
  thumbnail_medium_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/medium/download-3-thumbnail.jpg'
  thumbnail_photo_id: number // 8458044
  thumbnail_portrait_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/portrait/download-3-thumbnail.jpg'
  thumbnail_quad16_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/quad16/download-3-thumbnail.jpg'
  thumbnail_quad50_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/quad50/download-3-thumbnail.jpg'
  thumbnail_quad75_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/quad75/download-3-thumbnail.jpg'
  thumbnail_quad100_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/quad100/download-3-thumbnail.jpg'
  thumbnail_small_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/small/download-3-thumbnail.jpg'
  thumbnail_standard_download: string // '/7340/8458044/a1e9d845e850e2b97b3c476ef57941eb/standard/download-3-thumbnail.jpg'
  thumbnail_stock_p: boolean // true
  thumbnail_token: string // 'a1e9d845e850e2b97b3c476ef57941eb'
  thumbnail_tree_id: number // 7340
  timezone_offset: number // 2
  token: string // '4b73f30afab7477908c0'
  updated_date: string // '2023-10-17 11:24:56.059668+00'
  updated_date__date: string // 'October 17, 2023'
  video_360_p: boolean // false
  webinar_quality: string // ''
  webinar_waiting_room_buffer: string // '60 minutes'
  alias_count: number // 0
  combined_conversion_views: number // 0
  combined_conversion_views_fmt: string // "0"
  combined_conversion_view_rate: number // 0
  combined_conversion_view_rate_fmt: string // 0%
  combined_conversion_engagement_fmt: string // "0s"
  combined_conversion_engagement_per_view_fmt: string // "0s"
  combined_conversion_conversions_fmt: string // "0"
  combined_conversion_conversions: number // 0
  recording_duration_fmt: string // "0s"
}

type DetailedWebinarDTO = WebinarDTO & {
  // -- properties are only available if request contains `include_stats_p: true`
  number_of_recordings: number // 556
  primary_recording_photo_id: number // 8458041
  // --

  // -- properties are only available if request contains `include_trailer_p: true`
  trailer_embed_code: string // "<div style=\"width:100%; height:0; position: relative; padding-bottom:56.24999999296875%\"><iframe id=\"trailerplayer\" src=\"https://demo.ranguinc.com/v.ihtml/player.html?token=e51512502d4b14419cf16488f50d99db&showDescriptions=0&source=site&photo%5fid=8489804\" style=\"width:100%; height:100%; position: absolute; top: 0; left: 0;\" frameborder=\"0\" border=\"0\" scrolling=\"no\" allowfullscreen allow=\"autoplay; fullscreen\"></iframe></div>"
  trailer_photo_album_title: string | number // 123 NOTE(kasperkronborg): If an album title is only consistant of numbers, trailer_photo_album_title will be a number type.
  trailer_photo_id: number | '' // 8489804
  trailer_photo_title: string | number // Hello There NOTE(kasperkronborg): The same is most likely true for this as with trailer_photo_album_title.
  trailer_token: string // "e51512502d4b14419cf16488f50d99db"
  // --

  // -- properties are only available if request contains `include_live_series_p: true`
  live_series_number_of_draft_sessions: number
  live_series_name: string
  live_series_thumbnail_url: string
  live_series_id: number
  live_series_number_of_sessions: number
  // --
}

type Webinar = {
  id: number
  token: string
  title: string
  link: string
  description: string
  broadcastingDuration: number
  broadcastingDurationFmt: string
  descriptionHtml: string
  thumbnailQuad16: string
  thumbnailQuad50: string
  thumbnailQuad75: string
  thumbnailQuad100: string
  thumbnailPortrait: string
  thumbnailSmallUrl: string
  thumbnailMediumUrl: string
  thumbnailStandardUrl: string
  thumbnailLargeUrl: string
  state:
    | 'cancelled'
    | 'draft'
    | 'live'
    | 'ondemand'
    | 'past'
    | 'published'
    | 'scheduled'
    | 'secret'
    | 'unpublished'
    | 'upcoming'
    | 'waiting'
    | 'waitingroom'
    | 'new'
    | 'deleted'
  stateLabel:
    | 'Live'
    | 'Waiting Room'
    | 'Upcoming'
    | 'On Demand'
    | 'Draft'
    | 'Deleted'
  speakers: WebinarSpeaker[]
  engagement: string
  attendeeCountFmt: string
  broadcasting: boolean
  startDateFormatted: string
  startTimeFormatted: string
  startDateFullFormatted: string
  startDateByTimezoneFormatted: string
  startTimeByTimezoneFormatted: string
  startDateByTimezoneFullFormatted: string
  startDate: Date
  format: 'webinar'
  registrantsCount: number
  registrantsCountFmt: string
  questionMode: 'ask' | 'none'
  commentMode: 'all' | 'none'
  isTemplate: boolean
  areRawFilesAvailable: boolean
  duration: number | undefined
  timezone: string
  locale: string
  registrationMode: 'all' | 'none'
  streamingMethod:
    | 'mobile'
    | 'software'
    | 'iphone'
    | 'hardware'
    | 'webcam'
    | 'android'
  registrationPageLink: string
  attendees: number
  categoryId: number
  isPrivate: boolean
  isDraft: boolean
  isCancelled: boolean
  liveConversionViews: number
  attendanceRate: string
  isOnDemand: boolean
  albums: { id: number; name: string; content: string; contentText: string }[]
  thumbnailExists: boolean
}

// may not need all these properties here
export type WebinarSpeakerDTO = {
  email: string
  id: number
  name: string
  title: string
  company: string
  has_avatar_p: boolean
  hidden_p: boolean
  sortkey: number
  creation_time: string
  avatar_url: string
}

export type WebinarSpeaker = {
  email: string
  liveSpeakerId: number
  name: string
  title: string
  company: string
  hasAvatar: boolean
  isHidden: boolean
  sortKey: number
  creationTime: string
  avatarUrl: string
}

const mapDTOtoWebinar = (dto: WebinarDTO | undefined): Webinar => {
  if (dto === undefined) {
    return {
      attendeeCountFmt: '0',
      id: -1,
      title: 'This webinar has been deleted',
      description: '',
      broadcastingDuration: 0,
      broadcastingDurationFmt: '',
      descriptionHtml: '',
      link: '',
      engagement: '0s',
      token: '',
      thumbnailQuad16: '',
      thumbnailQuad50: '',
      thumbnailQuad75: '',
      thumbnailQuad100: '',
      thumbnailPortrait: '',
      thumbnailSmallUrl: '',
      thumbnailMediumUrl: '',
      thumbnailStandardUrl: '',
      format: 'webinar',
      state: 'deleted',
      stateLabel: 'Deleted',
      thumbnailLargeUrl: '',
      broadcasting: false,
      startDateFormatted: '',
      startTimeFormatted: '',
      startDateFullFormatted: '',
      startDateByTimezoneFormatted: '',
      startTimeByTimezoneFormatted: '',
      startDateByTimezoneFullFormatted: '',
      startDate: new Date(),
      speakers: [],
      registrantsCount: 0,
      registrantsCountFmt: '0',
      questionMode: 'none',
      commentMode: 'none',
      isTemplate: false,
      areRawFilesAvailable: false,
      duration: 15,
      timezone: 'Europe/Copenhagen',
      locale: 'en_US',
      registrationMode: 'all',
      streamingMethod: 'webcam',
      registrationPageLink: '',
      attendees: 0,
      categoryId: 0,
      isDraft: true,
      isPrivate: false,
      isCancelled: false,
      liveConversionViews: 0,
      attendanceRate: '0%',
      isOnDemand: false,
      albums: [],
      thumbnailExists: false,
    }
  }

  let stateLabel = dto.live_label as Webinar['stateLabel']
  let state: Webinar['state'] = stateLabel.toLowerCase() as Webinar['state']
  if (dto.live_status === 'live' && !dto.broadcasting_p) {
    state = 'waitingroom'
    stateLabel = 'Waiting Room'
  } else if (state === 'ondemand') {
    stateLabel = 'On Demand'
  }
  const webinarSpeakersDTOs = dto.speakers

  const webinarSpeakers = webinarSpeakersDTOs.map((WebinarSpeakerDTO) => ({
    email: WebinarSpeakerDTO.email,
    liveSpeakerId: WebinarSpeakerDTO.id,
    name: WebinarSpeakerDTO.name,
    title: WebinarSpeakerDTO.title,
    company: WebinarSpeakerDTO.company,
    hasAvatar: WebinarSpeakerDTO.has_avatar_p,
    isHidden: WebinarSpeakerDTO.hidden_p,
    sortKey: WebinarSpeakerDTO.sortkey,
    creationTime: WebinarSpeakerDTO.creation_time,
    avatarUrl: WebinarSpeakerDTO.avatar_url,
  }))

  return {
    attendeeCountFmt: dto.combined_conversion_views_fmt,
    registrantsCount: dto.combined_conversion_conversions,
    registrantsCountFmt: dto.combined_conversion_conversions_fmt,
    id: dto.live_id,
    token: dto.token,
    engagement: dto.combined_conversion_engagement_fmt,
    title: dto.name,
    link: dto.link,
    description: dto.description_text,
    broadcastingDuration: dto.broadcasting_duration,
    broadcastingDurationFmt: dto.broadcasting_duration_fmt,
    descriptionHtml: dto.description_html,
    thumbnailQuad16: dto.thumbnail_quad16_download,
    thumbnailQuad50: dto.thumbnail_quad50_download,
    thumbnailQuad75: dto.thumbnail_quad75_download,
    thumbnailQuad100: dto.thumbnail_quad100_download,
    thumbnailPortrait: dto.thumbnail_portrait_download,
    thumbnailSmallUrl: dto.thumbnail_small_download,
    thumbnailMediumUrl: dto.thumbnail_medium_download,
    thumbnailStandardUrl: dto.thumbnail_standard_download,
    format: dto.live_format,
    state,
    stateLabel,
    thumbnailLargeUrl: dto.thumbnail_large_download,
    broadcasting: dto.broadcasting_p,
    startDateFormatted: dto.live_date__date,
    startTimeFormatted: dto.live_date__time,
    startDateFullFormatted: dto.live_date,
    startDateByTimezoneFormatted: dto.primary_timezone_live_date__date,
    startTimeByTimezoneFormatted: dto.primary_timezone_live_date__time,
    startDateByTimezoneFullFormatted: dto.primary_timezone_live_date,
    speakers: webinarSpeakers,
    startDate: new Date(dto.live_date_epoch * 1000),
    questionMode: dto.question_mode,
    commentMode: dto.comment_mode,
    isTemplate: dto.template_p,
    areRawFilesAvailable: dto.can_download_webinar_recording_p,
    duration: dto.duration_minutes === '' ? undefined : dto.duration_minutes,
    timezone: dto.primary_timezone,
    locale: dto.locale,
    registrationMode: dto.registration_mode,
    streamingMethod: dto.streaming_method,
    registrationPageLink: dto.registration_page_link,
    attendees: dto.combined_conversion_views,
    categoryId: dto.album_id,
    isPrivate: dto.private_p,
    isDraft: dto.draft_p,
    isCancelled: dto.cancelled_p,
    liveConversionViews: dto.live_conversion_views,
    attendanceRate: dto.combined_conversion_view_rate_fmt,
    isOnDemand: dto.enable_ondemand_p,
    thumbnailExists: dto.thumbnail_stock_p,
    albums:
      dto.albums?.map((a) => ({
        id: a.album_id,
        name: a.title,
        content: a.content,
        contentText: a.content_text,
      })) ?? [],
  }
}

/**
 * DetailedWebinar
 *
 * This type should contain all the available properties available on a webinar
 * that has been fetch by the detailed webinar loader.
 */
type DetailedWebinar = Webinar & {
  numberOfRecordings: number
  primaryRecordingId: number
  trailerId: number | undefined
  liveSeriesDraftSessionCount: number
  liveSeriesPublishedSessionCount: number
  liveSeriesThumbnailUrl: string
  liveSeriesName: string
  liveSeriesId: number | undefined
}

const mapDTOtoDetailedWebinar = (dto: DetailedWebinarDTO): DetailedWebinar => {
  const webinar = mapDTOtoWebinar(dto)

  return {
    ...webinar,
    numberOfRecordings: dto.number_of_recordings,
    primaryRecordingId: dto.primary_recording_photo_id,
    trailerId: dto.trailer_photo_id === '' ? undefined : dto.trailer_photo_id,
    liveSeriesDraftSessionCount: dto.live_series_number_of_draft_sessions,
    liveSeriesThumbnailUrl: dto.live_series_thumbnail_url,
    liveSeriesName: dto.live_series_name,
    liveSeriesId: dto.live_series_id === '' ? undefined : dto.live_series_id,
    liveSeriesPublishedSessionCount: dto.live_series_number_of_sessions,
  }
}

export {
  type WebinarDTO,
  type DetailedWebinarDTO,
  type Webinar,
  type DetailedWebinar,
  mapDTOtoWebinar,
  mapDTOtoDetailedWebinar,
}

const webinarLoader = new DataLoader(
  async (webinarIds: readonly number[]) => {
    const response = await listWebinars<WebinarDTO>({
      selection: webinarIds.join(' '),
      size: 5000,
    })

    const videos = response.data.reduce<Record<number, WebinarDTO>>(
      (acc, webinarDTO) => {
        return { ...acc, [webinarDTO.live_id]: webinarDTO }
      },
      {}
    )
    return webinarIds.map((id) => videos[id])
  },
  { cache: false }
)

interface ListWebinarsParams {
  live_id?: number
  not_live_id?: number
  token?: string
  selection?: string
  promoted_p?: boolean
  streaming_p?: boolean
  upcoming_p?: boolean
  cancelled_p?: boolean
  include_stats_p?: boolean
  live_status?: string
  video_360_p?: boolean
  search?: string
  live_format?: string
  private_p?: boolean
  draft_p?: boolean
  include_speakers_p?: boolean
  include_trailer_p?: boolean
  /**
   * When set to false, it removes RTMP/Webinar joining details from the
   * response. Computation on Core includes signing, which is expensive.
   */
  include_publish_details_p?: boolean
  include_streaming_details_p?: boolean
  include_inactive_liveevents_p?: boolean
  include_fmle_url_p?: boolean
  include_album_p?: boolean
  use_full_urls_p?: boolean
  include_webinar_images_p?: boolean
  include_live_series_p?: boolean
  live_series_id?: number
  template_p?: boolean
  user_id?: string
  not_user_id?: string
  spot_id?: number
  spot_token?: string
  stream_preview_p?: boolean
  webrtc_publish_p?: boolean
  ordering?:
    | 'private'
    | 'promoted'
    | 'streaming'
    | 'broadcasting'
    | 'name'
    | 'live_label'
    | 'live_status'
    | 'live_date'
    | 'creation_date'
    | 'combined_conversion_engagement'
    | 'combined_conversion_conversions'
  order?: 'asc' | 'desc'
  selection_ordering?: string
  p?: number
  size?: number
  include_total_count_p?: number
  include_private_p?: boolean
}
const listWebinars = <T extends WebinarDTO>(params: ListWebinarsParams) => {
  const requestSettings = {
    url: '/api/2/live/list',
    method: HTTPMethod.GET,
    data: {
      include_publish_details_p: false,
      include_streaming_details_p: false,
      include_albums_p: true,
      ...params,
    },
  }
  return request<ApiResponse<T[]>>(requestSettings)
}

const WEBINAR_QUERY_KEY = 'webinar'
const PAGE_SIZE = 10

interface WebinarQueryKeyProps {
  webinarId: number
  includeStats?: boolean
  cleanSearch?: string
  workspaceId?: number
  liveSeriesId?: number
  autoMode?: 'previous' | 'live' | 'upcoming'
  order?:
    | 'live-status-asc'
    | 'live-date-desc'
    | 'live-date-asc'
    | 'name-asc'
    | undefined
  size?: number
  sortedByPopularity?: boolean
}

const webinarQueryKeys = {
  get: ({ webinarId, includeStats }: Partial<WebinarQueryKeyProps> = {}) =>
    [WEBINAR_QUERY_KEY, Number(webinarId), includeStats].filter(
      (el) => el !== undefined
    ),
  getDetailed: ({ webinarId }: Partial<WebinarQueryKeyProps>) => [
    WEBINAR_QUERY_KEY,
    Number(webinarId),
    'detailed',
  ],
  listWithRecording: ({ cleanSearch }: Partial<WebinarQueryKeyProps>) =>
    [WEBINAR_QUERY_KEY, 'list', 'withRecording', cleanSearch].filter(
      (el) => el !== undefined
    ),
  list: ({
    workspaceId,
    cleanSearch,
    size,
  }: Partial<WebinarQueryKeyProps> = {}) =>
    [WEBINAR_QUERY_KEY, 'list', workspaceId, size, cleanSearch].filter(
      (el) => el !== undefined
    ),
  nonUpcomingWebinarFormatWebinarsList: ({
    liveSeriesId,
  }: Partial<WebinarQueryKeyProps>) =>
    [
      WEBINAR_QUERY_KEY,
      'webinarFormatActiveWebinarsList',
      Number(liveSeriesId),
    ].filter((el) => el),
  webinarFormatList: ({
    liveSeriesId,
    order,
    sortedByPopularity,
  }: Partial<WebinarQueryKeyProps>) =>
    [
      WEBINAR_QUERY_KEY,
      'list',
      Number(liveSeriesId),
      order,
      sortedByPopularity,
    ].filter((el) => el !== undefined),
  infiniteList: ({
    workspaceId,
    cleanSearch,
    includeStats,
    order,
    sortedByPopularity,
  }: Partial<WebinarQueryKeyProps>) =>
    [
      WEBINAR_QUERY_KEY,
      'list',
      workspaceId,
      cleanSearch,
      includeStats,
      order,
      sortedByPopularity,
    ].filter((el) => el !== undefined),
  infiniteListNonDraft: ({ cleanSearch }: Partial<WebinarQueryKeyProps>) =>
    [WEBINAR_QUERY_KEY, 'list-non-draft', cleanSearch].filter(
      (el) => el !== undefined
    ),
  autoSpot: ({ autoMode, order, size }: Partial<WebinarQueryKeyProps>) =>
    [WEBINAR_QUERY_KEY, 'auto-spot', autoMode, order, size].filter(
      (el) => el !== undefined
    ),
}

const useWebinarQuery = (webinarId?: number, includeStats?: boolean) => {
  return useQuery(
    webinarQueryKeys.get({ webinarId, includeStats }),
    async () => {
      if (webinarId === undefined) {
        throw new Error('webinarId is required')
      }
      const webinar = mapDTOtoWebinar(await webinarLoader.load(webinarId))
      // an id of -1 means the webinar doesn't exist
      if (webinar.id === -1) {
        // we're keeping the id of the webinar, however, so we can perform operations with it
        // e.g. removing deleted webinars from webinar spots
        webinar.id = webinarId
      }
      return webinar
    },
    {
      enabled: !!webinarId,
      staleTime: 10 * 60 * 1e3, // 10 minutes
      cacheTime: 10 * 60 * 1e3, // 10 minutes
    }
  )
}

interface WebinarSeriesWebinarListSearchParams {
  workspaceId?: number
  status?: string
  includeStats?: boolean
  includeSpeakers?: boolean
  sortedByPopularity?: boolean
  webinarFormatId?: number
  reverseOrder?: boolean
  token?: string
}

const useWebinarFormatWebinarListInfiniteQuery = ({
  sortedByPopularity,
  webinarFormatId,
  reverseOrder = false,
  token,
}: WebinarSeriesWebinarListSearchParams) => {
  const queryClient = useQueryClient()

  return useInfiniteQuery(
    webinarQueryKeys.webinarFormatList({
      liveSeriesId: Number(webinarFormatId),
      order: reverseOrder ? 'live-date-asc' : 'live-date-desc',
      sortedByPopularity,
    }),
    async ({ pageParam = 1 }) => {
      const { data, p, total_count } = await listWebinars<DetailedWebinarDTO>({
        p: pageParam,
        size: PAGE_SIZE,
        include_speakers_p: true,
        ordering: sortedByPopularity
          ? 'combined_conversion_engagement'
          : 'live_date',
        order: reverseOrder ? 'asc' : 'desc',
        include_total_count_p: pageParam === 1 ? 1 : 0,
        live_series_id: webinarFormatId,
        include_stats_p: true,
        stream_preview_p: false,
        include_live_series_p: true,
        token,
      })

      const webinars = data.map(mapDTOtoDetailedWebinar)

      webinars.forEach((webinar: { id: number }) => {
        queryClient.setQueryData(
          webinarQueryKeys.getDetailed({ webinarId: webinar.id }),
          webinar
        )
      })

      const webinarIds = webinars.map((w: { id: number }) => w.id)

      return {
        webinars,
        webinarIds,
        page: p,
        nextPage: PAGE_SIZE * p < total_count ? p + 1 : undefined,
        previousPage: p > 1 ? p - 1 : undefined,
        totalCount: total_count,
      }
    },
    {
      keepPreviousData: true,
      staleTime: 5 * 60e3, // 5 minutes
      cacheTime: 5 * 60e3,
      getNextPageParam: (lastPage) => lastPage.nextPage,
      getPreviousPageParam: (firstPage) => firstPage.previousPage,
    }
  )
}

export {
  webinarQueryKeys,
  useWebinarQuery,
  useWebinarFormatWebinarListInfiniteQuery,
}
